import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import Icon from 'components/Icon';
import FlexBox from 'components/FlexBox';
import messages from '../../messages';
import Button from '../../../components/Button/Button';

export class ShowSupportingDocuments extends React.Component {
  constructor(props) {
    super(props);

    this.renderAttachment = this.renderAttachment.bind(this);
  }

  onRemove = (file) => {
    if (this.props.onDelete) {
      this.props.onDelete(file);
    }
  };

  onChange = (files) => {
    if (this.props.onChange) {
      this.props.onChange(files);
    }
  };

  onDrop = (files) => {
    this.onChange(files);
  };

  renderListAttachment() {
    const files = this.props.data;
    return (
      <div>
        {files.map((file, index) => this.renderAttachment(file, index))}
      </div>
    );
  }

  renderAttachment(file, index) {
    const { disabled, claimCode, requiredDocumentId, claimExpenseGuid } = this.props;
    // Filter logic: all must match
    if (
      file.benefitCode !== claimCode ||
      file.requiredDocumentId !== requiredDocumentId ||
      (claimExpenseGuid && file.claimExpenseGuid !== claimExpenseGuid)
    ) {
      return null;
    }

    return (
      <FlexBox
        justifyContent="space-between"
        style={{
          marginTop: 10,
          marginBottom: 10,
          backgroundColor: '#d1d1d1',
          padding: 10,
        }}
        key={index}
      >
        <span style={{ flex: 1, wordBreak: 'break-word' }}>{file.name}</span>
        {!disabled && (
          <Icon
            name="fa-trash-o"
            style={{ fontSize: 18, padding: 3, cursor: 'pointer' }}
            onClick={() => this.onRemove(file)}
          />
        )}
      </FlexBox>
    );
  }

  render() {
    const { disabled } = this.props;

    return (
      <div>
        {this.renderListAttachment()}
      </div>
    );
  }
}

ShowSupportingDocuments.propTypes = {
  onChange: PropTypes.func,
  data: PropTypes.array,
  onDelete: PropTypes.func,
  disabled: PropTypes.bool,
  claimCode: PropTypes.any,
  requiredDocumentId: PropTypes.any,
  claimExpenseGuid: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/components/ShowSupportingDocuments/index.js